import React from 'react';

import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// NOTE: These props are automatically passed to children
const FocusArrow = props => ( // eslint-disable-line no-unused-vars
  <svg viewBox="0 0 20 20" className="focusArrow">
    <path d="M0 0 L10 10 L0 20" />
  </svg>
);

// NOTE: These props are automatically passed to children
const InputLine = props => ( // eslint-disable-line no-unused-vars
  <svg className="inputLine" viewBox="0 0 40 2" preserveAspectRatio="none">
    <path d="M0 1 L40 1" />
    <path d="M0 1 L40 1" className="activeFocus" />
  </svg>
);

const textBasedInput = ['text', 'email', 'search', 'tel', 'number', 'password', 'url'];
const labelSupported = ['checkbox'];

// NOTE: Label uses appropriate nesting but eslint cannot tell from the children prop
const Label = (props) => {
  const {
    labelText, htmlFor, order, children, userSelect,
  } = props;
  return (
    <label htmlFor={htmlFor} style={!userSelect ? { userSelect: 'none' } : {}}> {/* eslint-disable-line jsx-a11y/label-has-for */}
      {order === 'reverse' && labelText}
      {children}
      {order === 'regular' && labelText}
    </label>
  );
};

const InputField = (props) => {
  const {
    defaultVal, change, fieldType, fieldName, fieldPlaceholder, icon, focus, fieldLabel, userSelect, title, line,
  } = props;
  if (fieldName === 'email') {
    return (
      <p className="emailField">
        {labelSupported.includes(fieldType) && fieldLabel && (
          <Label htmlFor={fieldName} labelText={fieldLabel} userSelect={userSelect}>
            <input
              defaultValue={defaultVal}
              onChange={change}
              type={fieldType}
              name={fieldName}
              id={fieldName}
              placeholder={textBasedInput.includes(fieldType) ? fieldPlaceholder : null}
              autoFocus={!!focus} // eslint-disable-line jsx-a11y/no-autofocus
            />
          </Label>
        )}
        {textBasedInput.includes(fieldType) && (
          <input
            defaultValue={defaultVal}
            onChange={change}
            type={fieldType}
            name={fieldName}
            placeholder={textBasedInput.includes(fieldType) ? fieldPlaceholder : null}
            required
            autoFocus={!!focus} // eslint-disable-line jsx-a11y/no-autofocus
            disabled
          />
        )}
        <FocusArrow />
        <FontAwesomeIcon icon={['fas', icon]} />
        {line && <InputLine />}
      </p>
    );
  }

  return (
    <p>
      {labelSupported.includes(fieldType) && fieldLabel && (
        <Label htmlFor={fieldName} labelText={fieldLabel} userSelect={userSelect}>
          <input
            defaultValue={defaultVal}
            onChange={change}
            type={fieldType}
            name={fieldName}
            id={fieldName}
            placeholder={textBasedInput.includes(fieldType) ? fieldPlaceholder : null}
            autoFocus={!!focus} // eslint-disable-line jsx-a11y/no-autofocus
          />
        </Label>
      )}
      {textBasedInput.includes(fieldType) && (
        <input
          defaultValue={defaultVal}
          onChange={change}
          type={fieldType}
          name={fieldName}
          placeholder={textBasedInput.includes(fieldType) ? fieldPlaceholder : null}
          required
          autoFocus={!!focus} // eslint-disable-line jsx-a11y/no-autofocus
        />
      )}
      <FocusArrow />
      <FontAwesomeIcon icon={['fas', icon]} />
      {line && <InputLine />}
    </p>
  );
};

export default InputField;

InputField.propTypes = {
  defaultVal: PropTypes.string,
  change: PropTypes.func.isRequired,
  icon: PropTypes.string,
  fieldType: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  fieldPlaceholder: PropTypes.string,
  fieldLabel: PropTypes.string,
  focus: PropTypes.bool,
  userSelect: PropTypes.bool,
  title: PropTypes.string,
};

InputField.defaultProps = {
  defaultVal: '',
  icon: null,
  fieldPlaceholder: null,
  fieldLabel: null,
  focus: false,
  userSelect: true,
  title: '',
};

Label.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  htmlFor: PropTypes.string.isRequired,
  order: PropTypes.string,
  labelText: PropTypes.string.isRequired,
  userSelect: PropTypes.bool,
};

Label.defaultProps = {
  order: 'regular',
  userSelect: true,
};
